import {Component, computed, input} from '@angular/core';
import {IdeaCategory} from '../../../../models/iackathon-save.state';
import {IackathonSave} from '../../../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-step-how-now-wow',
  imports: [],
  templateUrl: './iackathon-step-how-now-wow.component.html',
  styleUrl: './iackathon-step-how-now-wow.component.scss',
})
export class IackathonStepHowNowWowComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save().attributes.content.state);
    protected readonly sortedIdeas = computed(() => this.state().solution_step.sorted_ideas);
    protected readonly conventionalImpossible = computed(() => this.sortedIdeas().filter(i => i.category === IdeaCategory.ConventionalImpossible));
    protected readonly originalImpossible = computed(() => this.sortedIdeas().filter(i => i.category === IdeaCategory.OriginalImpossible));
    protected readonly conventionalPossible = computed(() => this.sortedIdeas().filter(i => i.category === IdeaCategory.ConventionalPossible));
    protected readonly originalPossible = computed(() => this.sortedIdeas().filter(i => i.category === IdeaCategory.OriginalPossible));
}
